import { NavLink } from 'react-router';
import styled, { css } from 'styled-components';

import { BREAKPOINTS } from '@shared/styled-system';

export const Wrapper = styled.div`
	display: none;
	align-items: center;
	width: 100%;

	@media (${BREAKPOINTS.DESKTOP}) {
		display: flex;
	}
`;

export const NavContainer = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	gap: 8px;
`;

export const LinkStyled = styled(NavLink)<{ $isActive?: boolean; $isBlitz?: boolean }>`
	display: inline-flex;
	align-items: center;
	padding: 6px 12px 6px 6px;
	border-radius: 100px;
	font-size: 20px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.subtitle};

	&.active {
		color: ${({ theme }) => theme.colors.control.primary};

		${({ $isBlitz }) =>
			$isBlitz &&
			css`
				color: ${({ theme }) => theme.colors.icon.notification};
			`}
	}
`;
